import React from 'react'

const SvgCreditCardOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20 8V6H4v2h16zm0 3H4v7h16v-7zM4 4h16c1.333 0 2 .667 2 2v12c0 1.338-.667 2.005-2 2H4c-1.333.005-2-.662-2-2V6c0-1.333.667-2 2-2zm7 10h5c.667 0 1 .333 1 1 0 .665-.333.998-1 .998h-5c-.667 0-1-.333-1-.999 0-.666.333-.999 1-.999zm-4 0h1c.667 0 1 .333 1 1 0 .665-.333.998-1 .998H7c-.667 0-1-.333-1-.999 0-.666.333-.999 1-.999z'
    />
  </svg>
)

export default SvgCreditCardOutline
